import React from "react"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import { Row, Col, BreadcrumbItem } from "reactstrap"
import back from "./../../assets/images/custom/back.png"

const Breadcrumb = props => {
  const { title, breadcrumbItems, backLink } = props
  const itemLength = breadcrumbItems.length
 
  return (
    <Row>
      <Col xs="12">
        <div className="page-title-box d-flex align-items-center justify-content-between">
          {backLink ? <h4 className="mb-0 font-size-18"><Link to={backLink || '#'} className="img-link"><img src={back} className="img-back"/> {title}</Link></h4>:null}
          
          <div className="page-title-right">
            <ol className="breadcrumb m-0">
              {breadcrumbItems.map((item, key) => (
                <BreadcrumbItem key={key} active={key + 1 === itemLength}>
                  <Link to={item.link || "#"}>{item.title}</Link>
                </BreadcrumbItem>
              ))}
            </ol>
          </div>
        </div>
      </Col>
    </Row>
  )
}

Breadcrumb.propTypes = {
  breadcrumbItems: PropTypes.array,
  title: PropTypes.string,
  backLink: PropTypes.string,
}

export default Breadcrumb
